import { render, staticRenderFns } from "./TestSection.vue?vue&type=template&id=14b8fdd8&scoped=true"
var script = {}
import style0 from "./TestSection.vue?vue&type=style&index=0&id=14b8fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8fdd8",
  null
  
)

export default component.exports